export const getCoursesList = state => state && state.getIn(['courses', 'list'])
export const getCourse = state => state && state.getIn(['courses', 'current'])
export const getItalyCourse = state => state && state.getIn(['courses', 'italy_current'])
export const getAscendant = state => state.getIn(['courses', 'ascendant'])
export const getCount = state => state.getIn(['courses', 'count'])

